// Inscription des écrans du lot 2 : routes de l'application (une ligne dans le routeur central).

import type { ReactElement } from 'react';
import { PageAlertes, PageFicheAlerte, PageReglesAlerte } from './Alertes';
import { PageApprovisionnements } from './Approvisionnements';
import { PageCargaison } from './Cargaison';
import { PageFicheStock } from './FicheStock';
import { PageGpl, PageSiteGpl } from './Gpl';
import { PageStocks } from './Stocks';

export const ROUTES_STOCKS: { chemin: string; element: ReactElement }[] = [
  { chemin: '/stocks', element: <PageStocks /> },
  { chemin: '/stocks/installations/:id', element: <PageFicheStock /> },
  { chemin: '/approvisionnements', element: <PageApprovisionnements /> },
  { chemin: '/approvisionnements/cargaisons/:id', element: <PageCargaison /> },
  { chemin: '/gpl', element: <PageGpl /> },
  { chemin: '/gpl/:id', element: <PageSiteGpl /> },
  { chemin: '/alertes', element: <PageAlertes /> },
  { chemin: '/alertes/regles', element: <PageReglesAlerte /> },
  { chemin: '/alertes/:id', element: <PageFicheAlerte /> },
];
